import React, { useState, useEffect } from 'react';
import {
  Heading,
  Flex,
  Box,
  Center,
  Button,
  IconButton,
} from '@chakra-ui/react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

import image1 from '../imgs/wallet.gif';
import image2 from '../imgs/restaurant.gif';
import image3 from '../imgs/marketplace.gif';

const sliderItems = [
  {
    image: image1,
    title: '',
    buttonText: 'Customer Login',
    buttonLink: '/customer-login', 
  },
  {
    image: image2,
    title: '',
    buttonText: 'Restaurant Login',
    buttonLink: '/restaurant-login', 
  },
  {
    image: image3,
    title: '',
    buttonText: 'Get Started',
    buttonLink: '/market-place', 
  },
];

const HomeScreen = ({ role, balance }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((prevSlide) => (prevSlide + 1) % sliderItems.length);
    }, 15000); // 15 seconds

    return () => clearInterval(timer);
  }, []);

  const goToPreviousSlide = () => {
    setActiveSlide((prevSlide) =>
      prevSlide === 0 ? sliderItems.length - 1 : prevSlide - 1
    );
  };

  const goToNextSlide = () => {
    setActiveSlide((prevSlide) => (prevSlide + 1) % sliderItems.length);
  };

  return (
    <Box p='4' minHeight='100vh' display='flex' flexDirection='column' alignItems='center'>      
      {/* Slider */}
      <Box
        width={['100%', '80%', '60%']}         
        position='relative'
        borderRadius='45px'
        border='1px solid'
        borderColor='blue.200'
        overflow='hidden'
      >
        {sliderItems.map((item, index) => (
          <Flex
            key={index}
            position='absolute'
            top='50%'
            left='50%'
            transform='translate(-50%, -50%)'
            flexDirection='column'
            alignItems='center'
            textAlign='center'
            zIndex={index === activeSlide ? '1' : '0'}
            opacity={index === activeSlide ? '1' : '0'}
            transition='opacity 0.5s'
          >
            <Heading as='h1' fontSize={['2xl', '3xl', '4xl']} color='white'>
              {item.title}
            </Heading>
          </Flex>
        ))}
        <img
          src={sliderItems[activeSlide].image} 
          alt='App Slider'
          width='100%'
        />
        <IconButton
          icon={<FiArrowLeft />}
          size='lg'
          colorScheme='white'
          position='absolute'
          top='50%'
          left='1%'
          transform='translateY(-50%)'
          onClick={goToPreviousSlide}
        />
        <IconButton
          icon={<FiArrowRight />}
          size='lg'
          colorScheme='white'
          position='absolute'
          top='50%'
          right='1%'
          transform='translateY(-50%)'
          onClick={goToNextSlide}
        />
      </Box>

      {/* Customer and Restaurant Login Buttons */}
      <Center my='4'>
        <Button as='a' href='/user-home' colorScheme='blue' bg='blue.200' mr='4' borderRadius='60px'>
          Customer Login
        </Button>
        <Button as='a' href='/restaurant' colorScheme='blue' bg='blue.200' borderRadius='60px'>
          Restaurant Login
        </Button>
      </Center>
    </Box>
  );
};

export default HomeScreen;
